module.exports = __webpack_public_path__ + "img/business-report.cedb5907.png";